<template>
  <b-row no-gutters id="dashboar-home" class="wrapper-content w-100">
    <b-col cols="12" class="wrapper-content">
      <b-row class="wrapper-title-page">
        <b-col cols="10" class="d-flex  align-items-center">
          <h4 class="page-title">{{ $t('Dashboard') }}</h4>
        </b-col>
        <b-col cols="2" class="d-flex  align-items-center">
          <LmBtnUpdateContent />
        </b-col>
      </b-row>
      <b-row>
        <component
          v-for="(componentData, index) in dashItems"
          :key="index"
          :is="componentData.component"
          v-bind="componentData.prop"
          :chart-data="componentData.chartData"
          :chart-option="componentData.chartOption"
          :class="{'lm-loader': componentData.component.startsWith('LmChart') ? loading : false }"
        />
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
// import apiSettings from '@/api/settings'
import { mapState, mapActions } from 'vuex'
import LmBtnUpdateContent from '@/components/LmBtnUpdateContent.vue'
export default {
  data () {
    return {
      componentsData: [],
      currentProperties: {}
    }
  },
  computed: {
    ...mapState('settings', ['dashItems', 'loading'])
  },
  components: {
    LmBtnUpdateContent
  },
  methods: {
    ...mapActions('settings', ['getDashSettings'])
  },
  created () {
    this.getDashSettings()
  }
}
</script>
